import { ActionIcon, Menu, Text } from '@mantine/core';
import { IconLogout, IconSwitchHorizontal, IconUser } from '@tabler/icons-react';
import * as React from 'react';

import { isNativeWebView, openChooseHost } from '@/utils/nativeWebView';

export type UserAvatarMenuProps = {
  avatarLetter: string | null;
  onLogout: () => void;
  avatarClassName?: string;
  dropdownClassName?: string;
};

const UserAvatarMenu: React.FC<UserAvatarMenuProps> = ({
  avatarLetter,
  onLogout,
  avatarClassName,
  dropdownClassName,
}) => (
  <Menu position="bottom-end" width={200} withinPortal trigger="click" closeOnItemClick>
    <Menu.Target>
      <ActionIcon
        variant="white"
        size="xl"
        className={avatarClassName}
        styles={{ root: { cursor: 'pointer', touchAction: 'manipulation', borderRadius: '50%' } }}
      >
        {avatarLetter ? (
          <Text size="xl" fw={700} c="blue">
            {avatarLetter}
          </Text>
        ) : (
          <IconUser size={20} style={{ color: 'var(--mantine-color-blue-filled)' }} />
        )}
      </ActionIcon>
    </Menu.Target>
    <Menu.Dropdown className={dropdownClassName}>
      {isNativeWebView() && (
        <Menu.Item leftSection={<IconSwitchHorizontal size={16} />} onClick={openChooseHost}>
          Сменить контур
        </Menu.Item>
      )}
      <Menu.Item leftSection={<IconLogout size={16} />} onClick={onLogout}>
        Выйти
      </Menu.Item>
    </Menu.Dropdown>
  </Menu>
);

export default UserAvatarMenu;
